import React from 'react';
import { useTranslation } from 'react-i18next';
import { SketchButton } from './sketchy';

export type AccountConflictMethod = 'google' | 'apple';

interface ExistingAccountConflictModalProps {
  isOpen: boolean;
  method: AccountConflictMethod;
  hasStorage?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
}

const ExistingAccountConflictModal: React.FC<ExistingAccountConflictModalProps> = ({
  isOpen,
  method,
  hasStorage = false,
  onConfirm,
  onCancel,
  busy = false,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const providerLabel = method === 'google' ? 'Google' : 'Apple';

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" data-testid="existing-account-conflict-modal">
      <div className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-xl shadow-lg p-6 max-w-md w-full mx-4" role="dialog">
        <h2 className="text-xl font-bold text-[var(--color-text)] mb-2">
          {t('auth.existingAccount.title')}
        </h2>
        <p className="text-[var(--color-muted)] mb-4 text-sm">
          {t('auth.existingAccount.message', { provider: providerLabel })}
        </p>
        <p className="text-sm text-[var(--color-text)] mb-4 p-3 rounded-lg border border-[var(--color-border)]/30 bg-[var(--color-hover)]/80">
          {hasStorage
            ? t('auth.existingAccount.guestContentWarningWithStorage')
            : t('auth.existingAccount.guestContentWarning')}
        </p>
        <div className="flex flex-col gap-2">
          <SketchButton onClick={onConfirm} disabled={busy} className="w-full">
            {t('auth.existingAccount.confirm')}
          </SketchButton>
          <SketchButton variant="ghost" onClick={onCancel} disabled={busy} className="w-full">
            {t('auth.existingAccount.cancel')}
          </SketchButton>
        </div>
      </div>
    </div>
  );
};

export default ExistingAccountConflictModal;
